import React from "react";
import MediaHero from "../../components/sections/media-room/Hero";
import MediaSection from "../../components/sections/media-room/MediaSection";

export default function MediaRoomPage() {
	return (
		<>
			<MediaHero />

			<MediaSection />
		</>
	);
}
